import { TASK_CONST } from '@/constant';
import { STATUS_BADGE_VARIANT } from '@/package/kiska/src/component/UI/VStatusBadge/constant';

export const FRAME_STATUS_BADGE_VARIANT_MAP = {
  [TASK_CONST.TASK_FRAME_WORKSTATE.REVIEWING]: STATUS_BADGE_VARIANT.IN_REVIEW,
  [TASK_CONST.TASK_FRAME_WORKSTATE.REVIEW]: STATUS_BADGE_VARIANT.SUBMITTED,
  [TASK_CONST.TASK_FRAME_WORKSTATE.REJECT]: STATUS_BADGE_VARIANT.REJECTED,
  [TASK_CONST.TASK_FRAME_WORKSTATE.DONE]: STATUS_BADGE_VARIANT.COMPLETED,
  [TASK_CONST.TASK_FRAME_WORKSTATE.WORKING]: STATUS_BADGE_VARIANT.IN_PROGRESS,
  [TASK_CONST.TASK_FRAME_WORKSTATE.PREWORK]: STATUS_BADGE_VARIANT.NOT_STARTED,
  [TASK_CONST.TASK_FRAME_WORKSTATE.VIEW_ONLY]: STATUS_BADGE_VARIANT.NOT_STARTED,
} as const;
